import React from 'react';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "../axios";
import { Devices } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function DeviceCreate() {
  const navigation = useNavigate();
  const [device, setDevice] = useState<Devices>({});

  const handleCreate = () => {
    console.log("Create");
    axios
      .post("/devices", device)
      .then((res) => {
        console.log("post result:" + res);
        navigation("/devices");
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const handleChangeDeviceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, device_id: event.target.value });
  };

  const handleChangeServiceId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, service_id: event.target.value });
  };

  const handleChangeAppId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, app_id: event.target.value });
  };

  const handleChangeAppVersion = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, app_version: event.target.value });
  };

  const handleChangeAppBuildNumber = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, app_build_number: event.target.value });
  };

  const handleChangeIccid = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, iccid: event.target.value });
  };

  const handleChangeImei = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, imei: event.target.value });
  };

  const handleChangeImsi = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, imsi: event.target.value });
  };

  const handleChangeModelName = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, model_name: event.target.value });
  };

  const handleChangeOsVersion = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setDevice({ ...device, os_version: event.target.value });
  };

  const handleChangeRootExploit = (
    event: SelectChangeEvent<string>
  ): void => {
    if (event.target.value === "false") {
      setDevice({ ...device, root_exploit: false });
    } else {
      setDevice({ ...device, root_exploit: true });
    }
  };

  const handleChangeKioskModeEnabled = (
    event: SelectChangeEvent<string>
  ): void => {
    if (event.target.value === "false") {
      setDevice({ ...device, kiosk_mode_enabled: false });
    } else {
      setDevice({ ...device, kiosk_mode_enabled: true });
    }
  };

  const handleChangeDeviceAvailable = (
    event: SelectChangeEvent<string>
  ): void => {
    if (event.target.value === "false") {
      setDevice({ ...device, device_available: false });
    } else {
      setDevice({ ...device, device_available: true });
    }
  };

  const handleChangeServiceAvailable = (
    event: SelectChangeEvent<string>
  ): void => {
    if (event.target.value === "false") {
      setDevice({ ...device, service_available: false });
    } else {
      setDevice({ ...device, service_available: true });
    }
  };

  const booleanValue = (bool: boolean | undefined) => {
    switch (bool) {
      case undefined:
        return "false";
      case true:
        return "true";
      case false:
        return "false";
    }
  }

  const booleanValueTrue = (bool: boolean | undefined) => {
    switch (bool) {
      case undefined:
        return "true";
      case true:
        return "true";
      case false:
        return "false";
    }
  }

  return (
    <Dashboard title="デバイス登録">
      <Table >
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="デバイスID"
                variant="outlined"
                required
                fullWidth
                value={device.device_id}
                onChange={handleChangeDeviceId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="サービスID"
                variant="outlined"
                required
                fullWidth
                value={device.service_id}
                onChange={handleChangeServiceId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリID"
                variant="outlined"
                required
                fullWidth
                value={device.app_id}
                onChange={handleChangeAppId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリバージョン"
                variant="outlined"
                required
                fullWidth
                value={device.app_version}
                onChange={handleChangeAppVersion}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリビルド番号"
                variant="outlined"
                required
                fullWidth
                value={device.app_build_number}
                onChange={handleChangeAppBuildNumber}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="ICCID"
                variant="outlined"
                required
                fullWidth
                value={device.iccid}
                onChange={handleChangeIccid}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="IMEI"
                variant="outlined"
                required
                fullWidth
                value={device.imei}
                onChange={handleChangeImei}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="IMSI"
                variant="outlined"
                required
                fullWidth
                value={device.imsi}
                onChange={handleChangeImsi}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="モデル名"
                variant="outlined"
                required
                fullWidth
                value={device.model_name}
                onChange={handleChangeModelName}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="OSバージョン"
                variant="outlined"
                required
                fullWidth
                value={device.os_version}
                onChange={handleChangeOsVersion}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="left">
              <FormControl variant="outlined" fullWidth>
                <InputLabel>root権限</InputLabel>
                <Select
                  label="root権限"
                  variant="outlined"
                  required
                  fullWidth
                  value={booleanValue(device.root_exploit)}
                  onChange={handleChangeRootExploit}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="left">
              <FormControl variant="outlined" fullWidth>
                <InputLabel>キオスクモード</InputLabel>
                <Select
                  label="キオスクモード"
                  variant="outlined"
                  required
                  fullWidth
                  value={booleanValueTrue(device.kiosk_mode_enabled)}
                  onChange={handleChangeKioskModeEnabled}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="left">
              <FormControl variant="outlined" fullWidth>
                <InputLabel>デバイス有効</InputLabel>
                <Select
                  label="デバイス有効"
                  variant="outlined"
                  required
                  fullWidth
                  value={booleanValueTrue(device.device_available)}
                  onChange={handleChangeDeviceAvailable}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="left">
              <FormControl variant="outlined" fullWidth>
                <InputLabel>サービス有効</InputLabel>
                <Select
                  label="サービス有効"
                  variant="outlined"
                  required
                  fullWidth
                  value={booleanValueTrue(device.service_available)}
                  onChange={handleChangeServiceAvailable}
                >
                  <MenuItem value="true">true</MenuItem>
                  <MenuItem value="false">false</MenuItem>
                </Select>
              </FormControl>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleCreate} sx={{ m: 1 }}>
          CREATE
        </Button>
      </Grid>
    </Dashboard>
  );
}
